module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_club.ver2_0_2.png?2a93aba2";